import React, { useState } from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import ProductTabMobile from '../../../../components/Sangjo-Ujieon/ProductTabMobile';

const ServiceAdvantagesMobile = () => {


  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="상품안내" />

        {/* Service Advantages Section */}
        <section className="event-procedure-mobile-section sky-hall-special-room-mobile-pricing-section">
          <ProductTabMobile selectedHall="서비스 장점" />

          {/* Header Section */}
          <div className="event-procedure-mobile-header-section">
            <div className="event-procedure-mobile-header-text">
              장례에서 장지까지, 유족의 마음과 <br /> 실용성을 모두 어우르는 <span>후불제 서비스</span>
            </div>
          </div>

          {/* Content Sections */}
          <div className="event-procedure-mobile-content-grid">
            {/* First Section */}
            <div className="event-procedure-mobile-content-section">
              <div className="event-procedure-mobile-image-container service-advantage">
                <img
                  src="/product/group-57.png"
                  alt="Handshake between funeral director and family"
                  className="event-procedure-mobile-image"
                />
              </div>
              <div className="event-procedure-mobile-text-content">
                <h3 className="event-procedure-mobile-section-title">한 번의 인연은 평생의 인연</h3>
                <p className="event-procedure-mobile-section-text">
                  후불제로 이용하는 것이라하여 일회성이라 여기지 않습니다. 처음 만남이기에 더욱 최선을 다하는 파라다이스 상조입니다. 파라다이스 추모원이 평생 함께 할 것을
                  약속 드립니다.

                </p>
              </div>
            </div>

            {/* Second Section */}
            <div className="event-procedure-mobile-content-section">
              <div className="event-procedure-mobile-image-container service-advantage">
                <img
                  src="/product/group-58.png"
                  alt="Laptop with credit card for payment"
                  className="event-procedure-mobile-image"
                />
              </div>
              <div className="event-procedure-mobile-text-content">
                <h3 className="event-procedure-mobile-section-title">안전하고 믿을 수 있는 후불제</h3>
                <p className="event-procedure-mobile-section-text">
                  상조 가입자 절반정도가 상조가입 후 1년 내에 30%
                  중도 해지를 합니다. 해지에는 다양한 이유가 있고,
                  실제로 환급금에 대한 고민들이 많습니다. 후불제로
                  운영하는 파라다이스 상조는 유족들의 이런 걱정을
                  덜어 드립니다.
                </p>
              </div>
            </div>

            {/* Third Section */}
            <div className="event-procedure-mobile-content-section">
              <div className="event-procedure-mobile-image-container service-advantage">
                <img
                  src="/product/group-59.png"
                  alt="Woman with smartphone"
                  className="event-procedure-mobile-image"
                />
              </div>
              <div className="event-procedure-mobile-text-content">
                <h3 className="event-procedure-mobile-section-title">정직한 가격과 전문적인 서비스</h3>
                <p className="event-procedure-mobile-section-text">
                거품이 없는 290만원의 가격으로 토탈장례서비스를 이용하실 수 있습니다. 10여년이 넘는 경력을 지닌 장례지도사가 자세히 안내해드립니다. 유족의 아픔과 슬픔을 함께 공감하며 정성으로 모시겠습니다.
                </p>
              </div>
            </div>
          </div>


        </section>

      </main>
    </div>
  );
};

export default ServiceAdvantagesMobile; 